<div class="searchContainer">
  <mat-form-field
    class="companySearch tw-bg-white tw-rounded-[5px] dark:tw-bg-gray-800"
    [floatLabel]="floatLabel"
    appearance="outline">
    <mat-label class="dark:tw-text-white">{{labelText}}</mat-label>
    <input
      matInput
      [formControl]="companyNameControl"
      [matAutocomplete]="auto"
      #autoInput="matAutocompleteTrigger"
      #inputField
      class="tw-text-dark-light-dynamic" />

    <mat-autocomplete
      #auto="matAutocomplete"
      class="searchAutocomplete"
      classList="searchAutocomplete"
      (optionSelected)="onCompanySelected($event)">
      <mat-option
        *ngFor="let searchItem of searchCompanies | async"
        [value]="searchItem"
        [class]="'tw-py-2 tw-border-0 tw-border-b tw-border-solid tw-border-gray-300'">
        <div class="searchCompanyItem">
          <div class="searchCompanyNameLine">
            <div class="tw-font-semibold">{{ searchItem.company.name }}</div>
            <div *ngIf="searchItem.company.linkedin">
              <a
                href="https://www.linkedin.com/company/{{searchItem.company.linkedin}}"
                target="_blank"
                class="tw-flex tw-w-4 tw-h-4">
                <img src="assets/img/linkedin-3-48.png" />
              </a>
            </div>
            <mat-chip-set>
              <mat-chip
                class="chipTicker tw-bg-slate-300 dark:tw-bg-slate-500 tw-text-white-dark-dynamic tw-text-xs"
                *ngIf="searchItem.company.ticker">
                <mat-icon>show_chart</mat-icon>
                {{searchItem.company.ticker}}
              </mat-chip>
            </mat-chip-set>
          </div>
          <div class="searchCompanyInfoLine tw-text-[12px] tw-flex-wrap">
            <div *ngIf="searchItem.type == 'company'" class="tw-font-bold">Company</div>
            <div
              *ngIf="searchItem.type == 'group'"
              class="tw-text-blue-600 tw-font-semibold tw-flex tw-items-center dark:tw-text-tropical-blue">
              <img
                src="../../assets/img/office-building.png"
                alt="office building conglomerate"
                class="tw-w-5 tw-align-middle" />
              <span>Conglomerate</span>
            </div>
            <div *ngIf="searchItem.company.industry">&#9679;</div>
            <div *ngIf="searchItem.company.industry">{{searchItem.company.industry}}</div>
            <div *ngIf="searchItem.type == 'group'">&#9679;</div>
            <div *ngIf="searchItem.type == 'group'">
              {{searchItem.company.grouped_company_count | number}} companies
            </div>
            <div *ngIf="searchItem.company.country">&#9679;</div>
            <div *ngIf="searchItem.company.country">{{searchItem.company.country}}</div>
          </div>
          <div
            *ngIf="searchItem.company.aliases.length > 0"
            class="tw-flex tw-flex-row tw-gap-1 tw-items-center tw-text-xs tw-overflow-hidden tw-whitespace-nowrap tw-text-ellipsis">
            <span class="tw-font-bold">Matching aliases:</span>
            <span
              *ngFor="let alias of searchItem.company.aliases"
              class="tw-bg-yellow-200 tw-inline-block tw-rounded-sm tw-py-0.5 tw-px-1 dark:tw-bg-yellow-400 dark:tw-text-gray-800">
              {{alias}}
            </span>
          </div>
        </div>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <div class="spinnerContainer">
    <mat-spinner *ngIf="searching" diameter="20"></mat-spinner>
  </div>
</div>
